<template>
  <div class="LyricsPanel">
    <MainPageHeader v-if="!isAndroidContext"/>
    <div :class="{'hidden-content': this.disabledScrollMainPage===true,
    'android-content': isAndroidContext}" class="content">
      <div v-if="!isAndroidContext" class="header">
        <h1 class="font-size-big">Moje piosenki</h1>
      </div>
      <div class="inner-content">
        <div class="button-wrapper">
          <SmallButton
            v-if="!isMassActionsEnabled"
            border-color="primary"
            class="add-button add-own-button"
            @click="showCreateLyrics">
            Dodaj piosenkę
          </SmallButton>
          <LyricsImport v-if="!isMassActionsEnabled" />
          <SmallButton
            v-if="!isMassActionsEnabled"
            @click="isMassActionsEnabled = true">
            Działania masowe
          </SmallButton>
          <SmallButton
            v-if="isMassActionsEnabled"
            @click="isMassActionsEnabled = false">
            Anuluj
          </SmallButton>
          <SmallButton
            v-if="isMassActionsEnabled"
            border-color="danger"
            :disabled="selectedLyrics.length === 0"
            @click="showDeleteLyricsPopup">
            Usuń zaznaczone
          </SmallButton>
        </div>
        <div class="lyrics-search">
          <LyricSearch
              :value="query"
              :isInputEmpty="isInputEmpty"
              :isLoading="isLoading"
              @input="handleSearchInput"
              @search="handleSearch"
          />
        </div>
        <div v-if="lyricsNotFound" class="info">
          <h2 class="font-size-middle">
            Brak szukanej piosenki. Upewnij się, że piosenka znajduje się w Twojej bibliotece, jeśli nie możesz ją
            dodać.
          </h2>
        </div>
        <div class="ph-item" v-if="bandLyricsApiCollection === null">
          <div class="ph-col-12">
            <div class="ph-row" v-for="n in 15" :key="n">
              <div class="big"></div>
              <div class="big gold"></div>
            </div>
          </div>
        </div>
        <div v-if="areSearchLyricsVisible" :class="lyricListClass" class="band-lyrics-list">
          <div v-for="lyric in lyrics" :key="lyric.key" :lyric="lyric" class="AccessLyrics">
            <button class="edit-lyric" @click="editBandLyric(lyric.id)">
              <div class="lyric-clip-wrapper">
                <img v-if="lyric.lyricsPictures.length>0" src="@/assets/images/attachmentIcon.png" alt="clip" 
                class="lyric-clip">
              </div>
              <div class="lyric-innerWrapper">
                <div class="title font-size-middle">
                <span :class="{ long: lyric.title.length > 70, short: lyric.title.length < 70}">
              {{ lyric.title }}</span>
                </div>
                <div class="edit-label font-size-middle">
                  <p>Edytuj</p>
                  <font-awesome-icon icon="pen"/>
                </div>
              </div>
            </button>
          </div>
        </div>
        <AddLyricsPopup v-if="addLyricsType === 'own'"
                        @close="hideAddLyricsPopup"/>
      </div>
      <div class="check-all-wrapper">
        <label class="lyric-checkbox-wrapper" v-if="isMassActionsEnabled">
          <span class="check-all">Zaznacz wszystkie</span>
          <input type="checkbox" class="lyric-checkbox" @click="handleCheckAll">
          <span class="checkbox-styled">
            <font-awesome-icon class="check" icon="check"/>
          </span>
        </label>
      </div>
      <div
          v-if="areBandLyricsVisible && bandLyricsApiCollection !== null"
          :class="lyricListClass"
          class="band-lyrics-list"
      >
        <div v-for="lyric in bandLyricsApiCollection.bandLyrics" :key="lyric.key" :lyric="lyric" class="AccessLyrics">
          <button class="edit-lyric" @click="editBandLyric(lyric.id)">
            <div class="lyric-clip-wrapper">
              <img v-if="lyric.lyricsPictures.length>0" src="@/assets/images/attachmentIcon.png" alt="clip"
              class="lyric-clip">
            </div>
            <div class="lyric-innerWrapper">
              <div class="title font-size-middle">
                <span :class="{ long: lyric.title.length > 70, short: lyric.title.length < 70}">
                {{ lyric.title }}</span>
              </div>
              <div class="edit-label font-size-middle">
                <p>Edytuj</p>
                <font-awesome-icon icon="pen"/>
              </div>
            </div>
          </button>
          <label class="lyric-checkbox-wrapper" v-if="isMassActionsEnabled">
            <input type="checkbox" :value="lyric['@id']" class="lyric-checkbox" v-model="selectedLyrics">
            <span class="checkbox-styled">
              <font-awesome-icon class="check" icon="check"/>
            </span>
          </label>
        </div>
        <div class="infinite-scroll" ref="infiniteScroll"></div>
      </div>
      <div v-if="bandLyricsApiCollection != null && !areSearchLyricsVisible">
        <p class="lyrics-counter font-size-middle">{{ visibleLyricsCounter }}</p>
      </div>
      <div v-if="isLoadingNextLyricsPages" class="loader"></div>
      <div class="info" v-if="bandLyricsNotFound === true">
        <p class="font-size-middle">
          Kliknij
          <a class="yellow-link" @click="showCreateLyrics">Dodaj własną</a>, aby dodać własną piosenkę,
        </p>
      </div>
    </div>
    <DeleteLyricsPopup
      v-if="isDeleteLyricsPopup"
      @cancel="isDeleteLyricsPopup = false"
      @delete="removeSelectedLyrics"  
      :numOfLyrics="numOfLyricsToDelete"
    />
    <Footer v-if="!isAndroidContext"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import SmallButton from '../components/input/SmallButton.vue'
import LyricSearch from '../components/LyricSearch.vue'
import LyricsImport from '@/views/LyricsImport.vue'
import AddLyricsPopup from '@/components/AddLyricsPopup'
import { getLyricsService } from '@/services/lyricsService'
import { createCancellable } from '@/helpers/asyncHelper'
import { getAuthService } from '../services/authService'
import '../../node_modules/placeholder-loading/src/scss/placeholder-loading.scss'
import Footer from '@/components/Footer'
import { getAndroidContext } from '@/services/sessionProps'
import { getBandLyricsService } from '@/services/bandLyricsService'
import DeleteLyricsPopup from '@/components/DeleteLyricsPopup'


export default {
  name: 'lyrics-panel',
  components: {
    Footer,
    MainPageHeader,
    SmallButton,
    LyricSearch,
    LyricsImport,
    DeleteLyricsPopup,
    AddLyricsPopup,
  },
  data () {
    return {
      lyrics: [],
      contentLoaded: false,
      query: '',
      searching: false,
      addLyricsType: this.$route.query.lyricsPopupType || null,
      bandLyricsApiCollection: this.showBandLyricsFirstPage(1),
      pages: this.bandLyricsApiCollection,
      bandLyricsNotFound: false,
      isInputEmpty: false,
      isLoading: false,
      lyricsNotFound: false,
      areSearchLyricsVisible: false,
      areBandLyricsVisible: true,
      observer: null,
      page: 1,
      initialLoading: true,
      isLoadingNextLyricsPages: false,
      disabledScrollMainPage: false,
      isAndroidContext: false,
      selectedLyrics: [],
      isDeleteLyricsPopup: false,
      isMassActionsEnabled: false,
      isCheckAll: false,
      numOfLyricsToDelete: 0,
    }
  },
  mounted () {
    window.scrollTo(0,0);
    if(this.$route.query.import === 'true') {
      this.$router.push({ name: 'android-lyrics-import' })
    }
    (async () => {
      this.isAndroidContext = getAndroidContext().isAndroidContext()
      const [
        loggedInEmail,
      ] = await Promise.all([
        getAuthService().getLoggedInEmail(),
      ])

      this.loggedInEmail = loggedInEmail
      if (this.loggedInEmail == null) {
        this.$router.replace({
          name: 'logInPage',
          params: {fromPage: 'lyrics'}
        })
      } else {
        if (this.$refs.popup !== undefined) {
          this.disabledScrollMainPage = true
        }

        this.bandLyricsApiCollection = null
        this.observer = new IntersectionObserver(this.onElementObserved, {
          threshold: 0.0,
        })
      }
    })()

  },
  methods: {
    showDeleteLyricsPopup() {
      this.numOfLyricsToDelete = this.isCheckAll
      ? this.bandLyricsApiCollection.totalItems
      : this.selectedLyrics.length

      this.isDeleteLyricsPopup = true
    },

    handleCheckAll() {
      this.isCheckAll = !this.isCheckAll
      this.checkAll()
    },

    checkAll() {
      let checkboxes = Array.from(document.querySelectorAll('.AccessLyrics .lyric-checkbox')),
          allValues = checkboxes.map((key) => {
            key.checked = this.isCheckAll
            return key.value })
      this.selectedLyrics = this.isCheckAll ? allValues : []
    },

    async removeSelectedLyrics () {
      const promises = []

      if(!this.isCheckAll) {
        for(const lyric of this.selectedLyrics) {
          let lyricItem = this.bandLyricsApiCollection.bandLyrics.filter(key => { return key['@id'] === lyric })[0]

          promises.push(getBandLyricsService().deleteBandLyric(lyricItem.id))
        }

        Promise.all(promises).then(() => {
          this.$router.go()
        })
      } else {
        await getBandLyricsService().deleteAllBandLyrics()

        this.$router.go()
      }
    },
    startUpload (num) {
      this.dataLoading.updatedLoading = true
      this.dataLoading.numOfFiles = num;
    },
    addToQueue(file) {
      this.dataLoading.allFiles.push(file);
      if(this.dataLoading.uploading === false) {
        this.uploadSingleFile(file);
      }
    },
    async uploadSingleFile(file) {
      this.dataLoading.uploading = true;
      this.dataLoading.file = file

      const payload = {
        key: null,
        title: file.name,
        content: '',
        lyricPictures: []
      }
      this.dataLoading.loadingName = file.name
      this.dataLoading.loadingOrder++

      try {
        const bandLyricResource = await getBandLyricsService().createBandLyric(payload)
        const imageResource = await getBandLyricsService().createBandLyricPicture(bandLyricResource.data.id,
        file.image, 
        this.dataLoading.loadingOrder)
        if(imageResource === null)
          this.$refs.Snackbar.showSnackbar("Błąd podczas przesyłania obrazka", "error")
      } catch(err) {
        console.log(err)
      }

      this.dataLoading.uploading = false;
      let idToRemove = this.dataLoading.allFiles.map(function(key) { return key.name }).indexOf(file.name);
      this.dataLoading.allFiles.splice(idToRemove, 1)
      if(this.dataLoading.allFiles.length > 0) {
        this.uploadSingleFile(this.dataLoading.allFiles[0]);
      } else {
        this.bandLyricsApiCollection = null
        this.observer = new IntersectionObserver(this.onElementObserved, {
            threshold: 0.0,
          })
        this.showBandLyricsFirstPage(1, true)
      }
    },
    async uploadFiles (allFiles) {
      this.dataLoading.updatedLoading = true
      this.dataLoading.files = allFiles
      
      for (const item of allFiles) {
        const payload = {
          key: null,
          title: item.name,
          content: '',
          lyricPictures: []
        }
        this.dataLoading.loadingName = item.name

        try {
          const bandLyricResource = await getBandLyricsService().createBandLyric(payload)
          this.dataLoading.loadingOrder++
          await getBandLyricsService().createBandLyricPicture(bandLyricResource.data.id, 
          item.image, 
          this.dataLoading.loadingOrder)
        } catch(err) {
          console.log(err);
        }
      }

      this.bandLyricsApiCollection = null
      this.observer = new IntersectionObserver(this.onElementObserved, {
          threshold: 0.0,
        })
      this.showBandLyricsFirstPage(1, true)
    },
    editBandLyric (id) {
      this.$router.push({ name: 'EditBandLyricPage', params: { id: id, allLyrics: this.bandLyricsApiCollection, 
      search: this.areSearchLyricsVisible } })
    },
    onElementObserved (entries) {
      if (entries[0].isIntersecting === true) {
        this.loadNextLyricsPages()
      }
    },
    observeScrollElement () {
      if (!this.bandLyricsNotFound && this.bandLyricsApiCollection != null) {
        setTimeout(() => {
          if (this.$refs.infiniteScroll != null) {
            this.observer.observe(this.$refs.infiniteScroll)
          }
        }, 1000)
      }
    },
    showCreateLyrics () {
      this.addLyricsType = 'own'
      this.$router.push({ name: 'CreateBandLyricPage', params: { duration: '1970-01-01T00:03:00+00:00' } })
    },
    showImportLyrics() {
      this.$router.push({ name: 'lyrics-import' })
    },
    getPages () {
      if (this.bandLyricsApiCollection && !this.bandLyricsNotFound) {
        const lastPage = this.bandLyricsApiCollection.lastPage.page
        const pages = []

        for (let i = 0; i < lastPage; i++) {
          pages[i] = i + 1
        }
        return pages
      }
    },
    async showBandLyricsFirstPage (page, notIncreasePage) {
      this.bandLyricsApiCollection = (await this.getBandLyrics(page))[0]
      if (this.bandLyricsApiCollection === null || this.bandLyricsApiCollection.bandLyrics.length === 0) {
        this.bandLyricsNotFound = true
      } else {
        this.observeScrollElement()
        this.bandLyricsNotFound = false
      }
      this.pages = this.getPages()
      this.initialLoading = false
      if (!notIncreasePage) {
        this.page++
      }
    },
    async loadNextLyricsPages () {
      if (
          !this.initialLoading &&
          !this.bandLyricsNotFound &&
          this.pages != null &&
          this.page <= this.pages[this.pages.length - 1]
      ) {
        this.isLoadingNextLyricsPages = true
        let newData = (await this.getBandLyrics(this.page))[0]
        this.bandLyricsApiCollection.bandLyrics = this.bandLyricsApiCollection.bandLyrics.concat(newData.bandLyrics)
        this.bandLyricsApiCollection.lastPage = newData.lastPage
        this.page++
        this.isLoadingNextLyricsPages = false

        this.$nextTick(() => {
            this.checkAll()
        })
      }
    },

    async getBandLyrics (page) {
      return await Promise.all([await getLyricsService().getBandLyrics(page)])
    },
    showAddOwnLyrics () {
      this.addLyricsType = 'own'
      this.$router.push({
        name: 'lyrics-panel',
        query: { lyricsPopupType: 'own' },
      })
    },
    async hideAddLyricsPopup () {
      this.disabledScrollMainPage = false
      let query = Object.assign({}, this.$route.query)
      delete query.lyricsPopupType
      delete query.page
      this.bandLyricsApiCollection = null
      this.bandLyricsNotFound = false
      this.addLyricsType = null
      await this.$router.replace({ query })
      this.page = 1
      await this.showBandLyricsFirstPage(1)
    },
    handleSearchInput (query) {
      this.query = query
      this.isInputEmpty = true
    },
    handleSearch (query) {
      this.searching = true
      this.isLoading = true

      if (this.lyricsFetchAction) {
        this.lyricsFetchAction.cancel()
      }

      this.lyricsFetchAction = createCancellable(() => getLyricsService().searchBandLyrics(query))

      if (query.length !== 0) {
        this.lyricsFetchAction().then((lyrics) => {
          this.lyrics = lyrics['hydra:member']
          this.searching = false
          this.isLoading = false
          this.areBandLyricsVisible = false
          this.areSearchLyricsVisible = true
          this.lyricsFetchAction = null
          this.lyricsNotFound = false
          if (this.lyrics.length === 0) {
            this.lyricsNotFound = true
          }
        })
      } else {
        this.searching = false
        this.isLoading = false
        this.lyrics = []
        this.lyricsFetchAction = null
        this.areSearchLyricsVisible = false
        this.areBandLyricsVisible = true
        this.lyricsNotFound = false
        this.isInputEmpty = false
        this.observeScrollElement()
      }
    },
    closePopup () {
      if (!this.dataLoading.updatedLoading) {
        this.hideAddLyricsPopup()
      }
    }
  },
  computed: {
    lyricListClass () {
      return {
        searching: this.searching,
      }
    },
    visibleLyricsCounter () {
      if (this.bandLyricsApiCollection?.bandLyrics) {
        return `Wczytano ${this.bandLyricsApiCollection.bandLyrics.length} 
        z ${this.bandLyricsApiCollection.totalItems} piosenek`
      } else {
        return ``
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $grey-light;
  border: thin solid $grey-light;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $dark-text;
  border: thin solid $dark-text;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $primary;
  border: thin solid $primary;
  border-radius: 10px;
}

.LyricsPanel {
  position: relative;
}

.hide-background {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: #1a1a1a;
  opacity: 0.5;
}

.content {
  box-sizing: border-box;
  margin: 90px auto auto;
  padding: 0 40px;
  min-height: calc(100vh - 358px);
  padding-bottom: 20px;

  @media (max-width: 600px) {
    padding: 0px 10px;
    .lyrics-search {
      padding: 10px;
    }
  }

  .loader {
    width: 20px;
    margin: 1px;
    font-size: 10px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    text-indent: -9999em;
    border-top: 0.5em solid $primary;
    border-right: 0.5em solid $primary;
    border-bottom: 0.5em solid $primary;
    border-left: 0.5em solid #ffffff;
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 0.8s infinite linear;
  }

  .loader,
  .loader:after {
    border-radius: 100%;
    width: 5em;
    height: 5em;
  }

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .header {
    h1 {
      color: #d6ae5d;
      border-bottom: 2px solid #fefefe;
      text-align: center;
      padding-bottom: 20px;
      margin-top: 0;
      margin-bottom: 30px;
      padding: 15px;

      @media screen and (max-width: $phone-max-width) {
        padding-top: 15px;
        margin-bottom: 20px;
      }
    }
  }

  .button-wrapper {
    margin-bottom: 40px;
    display: flex;
    justify-content: center;

    & > * {
      margin-right: 20px;
    }

    @media screen and (max-width: $phone-max-width) {
      flex-wrap: wrap;
      margin-bottom: 0;
      align-items: flex-start;

      & > * {
        margin-left: 20px;
      }
    }

    .add-button {
      border-width: 2px;
      border-radius: 6px;

      @media screen and (max-width: 439px) {
        margin-bottom: 15px;
      }
    }

    .add-own-button {
      border-color: white;
    }
  }

  .yellow-link {
    color: #d6ae5d;
    text-decoration: none;
    cursor: pointer;
  }

  .info {
    text-align: center;

    p {
      margin-top: 4px;
      margin-bottom: 0;
      color: darken(white, 20);
    }
  }

  .lyrics-search {
    display: flex;
    flex-direction: column;
    margin: auto;
    max-width: 380px;
  }

  .band-lyrics-list {
    position: relative;
    left: 20%;
    max-width: 60%;
    overflow: auto;
    margin-bottom: 20px;

    .infinite-scroll {
      pointer-events: none;
      z-index: -100;
      height: 400px;
      width: 100%;
      position: absolute;
      bottom: 0;
    }

    @media only screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
      left: 5%;
      max-width: 90%;
    }
    @media only screen and (max-width: $phone-max-width) {
      left: 5%;
      max-width: 90%;
    }

    .AccessLyrics {
      display: grid;
      grid-template-columns: 1fr 36px;

      .edit-lyric {
        cursor: pointer;
        padding: 0;
        padding-left: 2px;
        display: grid;
        border: none;
        grid-template-columns: 20px 1fr;
        background-color: transparent;
        overflow: hidden;
        @media only screen and (max-width: $phone-max-width) {
          grid-template-columns: 25px 1fr;
        }

        .lyric-innerWrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          border-bottom: 1px solid $dark-text;

          @media only screen and (max-width: $phone-max-width) {
            grid-template-columns: 1fr 40px;
          }
        }

        .lyric-clip-wrapper {
          height: auto;
          display: flex;
          justify-content: flex-start;
          align-self: center;
          .lyric-clip {
            height: 20px;
          }
        }

        .title {
          color: $dark-text;
          margin: 10px 0 auto 0;
          padding-left: 10px;
          position: relative;
          white-space: nowrap;
          overflow: hidden;
          text-align: left;
          padding-bottom: 5px;
          @media only screen and (min-width: 769px) {
            .long {
              display: inline-block;
              padding-left: 100%;
              animation: slide 20s linear infinite;
            }
          }
          @media only screen and (max-width: $phone-max-width) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          @keyframes slide {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-100%));
            }
          }

          @-webkit-keyframes slide {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-100%));
            }
          }
        }

        .edit-label {
          padding: 0;
          position: relative;
          margin-left: auto;
          margin-right: 0;
          margin-top: auto;
          margin-bottom: auto;
          width: 100px;
          height: 20px;
          @media only screen and (max-width: $phone-max-width) {
            width: 40px;
          }

          p {
            padding: 1px 0;
            margin: 0 !important;
            color: $dark-text;
            border: 1px solid white;
            border-radius: 5px;
          }

          svg {
            display: none;
          }

          @media only screen and (max-width: $phone-max-width) {
            p {
              display: none;
            }

            svg {
              display: block;
              margin-left: auto;
              margin-right: 10px;
              color: $dark-text;
            }
          }
        }
      }

      .lyric-checkbox-wrapper {
        align-self: center;
        width: 36px;
        text-align: center;

        input {
          cursor: pointer;
        }
      }
    }

    .AccessLyrics:hover {
      background-color: $list-row-focus;
      .edit-lyric {
        
        .title {
          color: white;
        }

        .edit-label {
          p {
            color: white;
            border-color: $primary;
          }

          svg {
            color: white;
          }
        }
      }
    }
  }
}

.android-content {
  margin-top: 30px;
}

.hidden-content {
  height: 300px;
  overflow: hidden;
  margin-top: 85px;
}

.lyrics-counter {
  text-align: center;
}

.ph-item {
  direction: ltr;
  position: relative;
  width: 60%;
  left: 20%;
  padding: 0;
  overflow: hidden;
  margin-bottom: 0;
  background-color: transparent;
  border: none;
  border-radius: none;

  &::before {
    display: none;
  }

  .ph-row {
    display: flex;
    justify-content: space-between;
    margin: 0;
    border-bottom: 1px solid #777;

    .big:first-child {
      width: 60%;
    }

    .big:last-child {
      width: 110px;
    }
  }

  .ph-col-12 {
    margin: 0;
    padding: 0;
  }

  .big {
    height: 22px;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
    background-color: #727271;
    margin: 11.5px 0;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 50%;
      width: 500%;
      margin-left: -250%;
      -webkit-animation: phAnimation 0.8s linear infinite;
      animation: phAnimation 0.8s linear infinite;
      background: linear-gradient(
              to right,
              rgba(255, 255, 255, 0) 46%,
              rgba(255, 255, 255, 0.35) 50%,
              rgba(255, 255, 255, 0) 54%
      ) 50% 50%;
      z-index: 0;
    }
  }

  .gold {
    background-color: #d6ae5d;
  }

  .ph-item > * {
    padding: 0;
  }
}

.hide-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

@media only screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .ph-item {
    width: 90%;
    left: 5%;

    .ph-row {
      .big:first-child {
        width: 100%;
      }

      .big:last-child {
        display: none;
      }
    }
  }
}

@media only screen and (max-width: $phone-max-width) {
  .ph-item {
    width: 90%;
    left: 5%;

    .ph-row {
      .big:first-child {
        width: 100%;
      }

      .big:last-child {
        display: none;
      }
    }
  }
}

.lyric-checkbox-wrapper {
  .checkbox-styled {
    cursor: pointer;
    user-select: none;
    padding: 1px 2px;
    background-color: #eee;
    border: solid 1px $primary;
    border-radius: 3px;
    color: #eee;
    font-size: 0.7em;
    transition: 0.1s ease-out background-color;

    &.disabled {
        pointer-events: none;
        opacity: 0.2;
    }

    .check {
        opacity: 0;
        transition: 0.2s ease-out opacity;
    }

    &.error {
        background-color: red;
    }
  }

  input[type=checkbox] {
    display:none;
    &:checked {
      & + .checkbox-styled {
        background-color: $primary;

        .check {
            opacity: 1;
        }
      }
    }
  }
}

.check-all-wrapper {
  left: 20%;
  position: relative;
  max-width: 60%;
  text-align: right;
  padding-right: 9px;
  height: 20px;
  .lyric-checkbox-wrapper > .check-all {
    margin-right: 1rem;
  }
}
</style>
